import { render, staticRenderFns } from "./UITopInvestorsWidget.vue?vue&type=template&id=3b480240"
import script from "./UITopInvestorsWidget.vue?vue&type=script&lang=js"
export * from "./UITopInvestorsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
